/**
 * A collection of basic math operations.
 */
export const math = {
  /**
   * Increments a number by a specified value.
   *
   * @param {number} x - The number to increment.
   * @param {number} [y=1] - The value to increment by (default is 1).
   * @returns {number} The result of adding `y` to `x`.
   */
  increment: (x, y = 1) => x + y,

  /**
   * Subtracts a specified value from a number.
   *
   * @param {number} x - The number to decrement.
   * @param {number} [y=1] - The value to subtract (default is 1).
   * @returns {number} The result of subtracting `y` from `x`.
   */
  subtract: (x, y = 1) => x - y,
};
